module.exports = __webpack_public_path__ + "img/pro_two_8.00248062.jpg";